import {
    InteractionEntity,
    InteractionEntityType,
    NoteEntity,
    NoteEntityType,
} from '../../../../../coaching-base/config';
import { PayloadAction } from '../../../../../store.model';
import { determineAllowedActions } from '../function/determine-allowed-actions.function';
import { setFocus } from '../function/set-focus.function';
import { ActionType } from '../teamschat-transcript-dialog.action';
import {
    defaultState,
    TeamschatTranscriptDialogState,
} from '../teamschat-transcript-dialog.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: TeamschatTranscriptDialogState,
    action: PayloadAction<ActionType.COACHING_DETAIL__TCTD__RELOAD, Reload>,
): TeamschatTranscriptDialogState {
    return defaultState();
}

export function reloadResultReducer(
    state: TeamschatTranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TCTD__RELOAD_RESULT,
        ReloadResult
    >,
): TeamschatTranscriptDialogState {
    const nextState: TeamschatTranscriptDialogState = { ...state };
    try {
        nextState.behaviours = action.payload.behaviours;
        nextState.subBehaviours = action.payload.subBehaviours;
        nextState.noteEntity = (
            action.payload.observationConfig?.childEntities?.find(
                (a) => a.entityType === InteractionEntityType,
            ) as InteractionEntity
        )?.childEntities.find(
            (e) => e.entityType === NoteEntityType,
        ) as NoteEntity;
        nextState.chat = action.payload.chat;
        nextState.messages = action.payload.messages;
        nextState.filteredQuotes =
            nextState.messages != null ? [...nextState.messages].reverse() : [];
        nextState.filterOpts = {
            ...state.filterOpts,
            keyword: null,
            dateRange: {
                from: nextState.messages?.at(-1)?.startTime,
                to:
                    nextState.messages?.[0]?.endTime ??
                    nextState.messages?.[0]?.startTime,
            },
        };
        nextState.focus = setFocus(
            action.payload.behaviourId,
            action.payload.subBehaviourId,
            nextState.behaviours,
            nextState.subBehaviours,
        );
        nextState.allowedActions = determineAllowedActions();
        nextState.cmtNotesFocus = nextState.focus;
        nextState.selectedQuotes = undefined;
        nextState.filteredQuotesSelectedLookup = {};
        nextState.allQuotesAreSelected = undefined;
    } catch (err) {
        console.log(err);
    }
    return nextState;
}
